var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tenpercent"},[_c('div',{staticClass:"tenpercent_left"},[_c('p',[_vm._v("八号地云服务收银系统1.0版本在南京多家门店测试使用")])]),_c('div',{staticClass:"center_content"},[_c('div',{staticClass:"sphere"})]),_c('div',{staticClass:"tenpercent_right"},[_c('div',{staticClass:"right_bootom"}),_c('p',[_vm._v("2018.04.06")])])])
}]

export { render, staticRenderFns }